export  var questions=[
    {
        no:1,
        question:"5+7-2+4-8",
        ans:6
    },
    {
        no:2,
        question:"7-11+9+6",
        ans:11
    },
    {
        no:3,
        question:"15+7-12+4-8",
        ans:6
    },
    {
        no:4,
        question:"2+2+3+7+5",
        ans:19
    },
    {
        no:5,
        question:"102+3+4",
        ans:109
    },
    {
        no:6,
        question:"9-5-4-7+1",
        ans:-6
    },
    {
        no:7,
        question:"13+27+3-25",
        ans:18
    },
    {
        no:8,
        question:"5+17-24",
        ans:-2
    },
    {
        no:9,
        question:"57-28-9",
        ans:20
    },
    {
        no:10,
        question:"2+2+3+7+8+2+7",
        ans:31
    },
]